
<sidebar-layout-item class="cmp-contact-form-user-data">
  <q-form ref="form" novalidate>
    <h5>
      {{ $t('scf.user_data.title') }}
    </h5>
    <small>
      {{ $t('scf.user_data.info') }}
    </small>

    <ws-btn-toggle
      v-model="userExistence"
      class="q-mt-2xl"
      :options="[
        { value: 'new', label: 'scf.user_data.new' },
        { value: 'old', label: 'scf.user_data.old' },
      ]"
    />

    <contact-form-user-new
      v-if="userExistence === 'new'"
      v-model="model.contact"
      class="q-mt-lg"
    />

    <contact-form-user-old
      v-else-if="userExistence === 'old'"
      v-model="model"
      class="q-mt-lg"
      @loading="loading = $event"
    />

    <ws-input
      v-if="usecase === CF_USECASE.MANAGEMENT"
      v-model="model.note"
      type="textarea"
      class="ws-textarea"
      autogrow
      banner
      messages-overflow
      :label="$t('scf.user_data.note')"
      debounce="300"
      @input="reEmit"
    />

    <ws-input
      v-if="usecase === CF_USECASE.MONITORING"
      v-model="model.name"
      name="name"
      class="server-name"
      :label="$t('scf.user_old.server_name')"
      :path="'scf.name'"
      required
      :rules="[required, ...serverNameRules]"
      :restrict="serverNameRestriction"
      @input="reEmit"
    />

    <consent-checkboxes
      ref="consents"
      force-required
      class="text-left q-mt-2xl"
    />
  </q-form>
</sidebar-layout-item>
